module.exports = __webpack_public_path__ + "static/media/sql-logo.21812f6d.png";